var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserManual(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-kit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.125,0.300845885 L2.625,0.300845885 C1.18125,0.300845885 0.013125,1.47084588 0.013125,2.90084588 L0,23.7008459 C0,25.1308459 1.168125,26.3008459 2.611875,26.3008459 L18.375,26.3008459 C19.81875,26.3008459 21,25.1308459 21,23.7008459 L21,10.3008459 L11.9923363,0.300845885 L13.125,0.300845885 Z M3,23.3008459 L3,21.3008459 L19,21.3008459 L19,23.3008459 L3,23.3008459 Z M3,19.3008459 L3,17.3008459 L16,17.3008459 L16,19.3008459 L3,19.3008459 Z M3,15.3008459 L3,13.3008459 L18,13.3008459 L18,15.3008459 L3,15.3008459 Z M3,11.3008459 L3,9.30084588 L10,9.30084588 L10,11.3008459 L3,11.3008459 Z M3,7.30084588 L3,5.30084588 L10,5.30084588 L10,7.30084588 L3,7.30084588 Z M11.9923363,3.36958291 L19.066555,11.3596456 L11.9923363,11.3596456 L11.9923363,3.36958291 Z",
    id: "path-user-kit-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 66.6666667,
    height: 66.6666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,27 C0,12.0883118 12.0850331,0 27,0 L27,0 C41.9116882,0 54,12.0850331 54,27 L54,27 C54,41.9116882 41.9149669,54 27,54 L27,54 C12.0883118,54 0,41.9149669 0,27 L0,27 Z",
    id: "Background",
    fill: "#00FFD8",
    opacity: 0.380260649
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#009D84",
    opacity: 0.23,
    points: "14.0639606 10.0647636 24 10.0647636 32.1575675 18 32.1575675 34.0572299 12.9948983 34.0572299"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_description",
    transform: "translate(12.000000, 8.699154)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-123",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-user-kit-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-123)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.333333, -20.032487)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Black",
    stroke: "none",
    fill: "#009D84",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#00FFD8",
    cx: 43,
    cy: 43,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-small-/-add-copy-user-manual",
    transform: "translate(27.000000, 26.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,12 L22,21 L20,21 L19.9994949,15.506 L12.8137085,22.6923882 L11.3994949,21.2781746 L18.6774949,13.999 L13,14 L13,12 L22,12 Z",
    id: "Combined-Shape"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManual);
export default __webpack_public_path__ + "static/media/user-manual.0e501f1ac4cc20e7b6929e487c7dd145.svg";
export { ForwardRef as ReactComponent };